<template>
  <div class="bookgroup">
    <div class="campus">教材系列</div>
    <el-card :span="24">
      <div class="header">教材系列</div>
      <div class="content">
        <div class="tableStyle">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="picurl" label="教材系列头像" min-width="50" align="center">
              <template slot-scope="scope"><img height="80px" v-if="scope.row.picurl" :src="scope.row.picurl" alt="">
                <span v-else>暂无头像</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="教材系列名称" min-width="50" align="center">
            </el-table-column>
            <el-table-column prop="seqnum" label="教材序列序号" min-width="50" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div class="dz-flex dz-flex-justify-end mt-12">
          <el-pagination background @size-change="getBookGroupList" @current-change="getBookGroupList" :current-page.sync="page" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { $getBookGroupList, $addBookGroup, $editBookGroup } from '@/api/press';
import { $debounce } from '@/utils/index';

const FormRules = {
  name: [
    {
      required: true,
      message: '请输入教材分类',
      trigger: ['blur', 'change'],
    },
  ],
  seqnum: [
    {
      required: true,
      message: '请选择排序',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  name: 'bookgroup',
  props: ['id'],
  data() {
    return {
      pressList: [],
      // publisherid: '',
      FormRules,
      tableData: [],

      page: 1,
      pageSize: 10,
      total: 0,

      publicDialog: false,
      dialogType: '',
      forms: {},
    };
  },
  created() {
      this.getBookGroupList();
    
  },
  methods: {
    async getBookGroupList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookgroup/getBookGroupListPage',
        method:'POST',
        data: {
          orgid: window.sessionStorage.getItem('orgid'),
          publisherid:this.$route.query.id,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          console.log(result);
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
  },
};
</script>

<style lang="less">
.bookgroup {
  .el-card__body {
    padding: 0 1.3vw;
  }
}
</style>